"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const store_1 = __importDefault(require("../../../store"));
const image_1 = require("@app/image");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
require("./index.scss");
const Sentry = __importStar(require("@sentry/browser"));
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: null,
            errInfo: null,
            browserInfo: null,
            loading: true,
            isExpanded: window.location.hostname === 'localhost',
            currentCommit: window.localStorage.getItem('ds-current-commit'),
            alreadyReported: false,
        };
    }
    async init() {
        // this is where i18n gets bootstrapped for the whole app. A stored locale is the
        // language picker's choice from a previous visit; without one, i18nConfig falls
        // back to the browser's own language, as it always has
        await (0, util_1.i18nConfig)(store_1.default.getState().locale);
        const browser = util_1.miscUtil.getBrowser();
        this.setState((oldState) => ({
            ...oldState,
            browserInfo: browser,
            loading: false,
        }));
    }
    componentDidMount() {
        this.init();
    }
    componentDidCatch(error, info) {
        this.setState({
            hasError: error,
            errInfo: info,
        });
        document.title = 'Dayswaps Error';
        console.log(window.location.href, error, info);
        Sentry.captureException(error, (scope) => {
            scope.setTag('scope', 'error-boundary');
            scope.setContext('componentStack', info?.componentStack);
            return scope;
        });
    }
    render() {
        if (this.state.loading)
            return null;
        if (this.state.hasError) {
            return (react_1.default.createElement("div", { className: 'ds-error-boundary' },
                react_1.default.createElement("div", { className: 'content' },
                    react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN, stretch: true },
                        react_1.default.createElement(image_1.LogoWide, null),
                        react_1.default.createElement("div", null, window.location.hostname === 'localhost' && (react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1, size: _ui_1.Icon.SIZES.LARGE, onClick: () => this.setState({ hasError: null }) })))),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_96 }),
                    react_1.default.createElement(_ui_1.Flex, { grow: 1 },
                        react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN, align: _ui_1.Flex.POSITION.CENTER },
                            react_1.default.createElement(_ui_1.Text, { text: (0, util_1.t)('ERROR_SCREEN_TITLE'), type: _ui_1.Text.TYPES.HEADLINE1, weight: _ui_1.Text.WEIGHTS.BOLD, color: _ui_1.Text.COLORS.WHITE }),
                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_12 }),
                            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.PARAGRAPH, color: _ui_1.Text.COLORS.WHITE, weight: _ui_1.Text.WEIGHTS.MEDIUM, align: _ui_1.Text.ALIGN.CENTER },
                                (0, util_1.t)('ERROR_SCREEN_TITLE_RETRY'),
                                react_1.default.createElement("br", null),
                                (0, util_1.t)('ERROR_SCREEN_HELP_TROUBLESHOOTING'),
                                react_1.default.createElement("br", null),
                                react_1.default.createElement("br", null),
                                store_1.default.getState().meta.commit,
                                react_1.default.createElement("br", null),
                                store_1.default.getState().meta.version),
                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_24 }),
                            react_1.default.createElement(_ui_1.Button, { size: _ui_1.Button.SIZES.EXTRA, style: _ui_1.Button.STYLES.CONTAINED, label: (0, util_1.t)('RETURN_BACK'), bold: true, onClick: () => {
                                    window.history.back();
                                    this.setState({ hasError: null });
                                    window.location.reload();
                                } }),
                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_32 }),
                            react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.UNDERLINED, color: _ui_1.Button.COLORS.WHITE, onClick: () => this.setState({ isExpanded: !this.state.isExpanded }) },
                                react_1.default.createElement(_ui_1.Flex, null,
                                    react_1.default.createElement("div", null, (0, util_1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_SHOW_DETAIL')),
                                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                                    react_1.default.createElement(_ui_1.Icon, { ico: this.state.isExpanded
                                            ? _ui_1.Icon.ICONS.arrowDown
                                            : _ui_1.Icon.ICONS.arrowUp, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.WHITE }))),
                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16 }),
                            this.state.isExpanded && (react_1.default.createElement(_ui_1.Card, { width: '100%' },
                                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                                    react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN },
                                        this.state.browserInfo && (react_1.default.createElement(_ui_1.Text, { color: _ui_1.Text.COLORS.BLACK, weight: _ui_1.Text.WEIGHTS.BOLD }, `${this.state.browserInfo.name} ${this.state.browserInfo.version}`)),
                                        react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.duplicate, onClick: () => util_1.miscUtil.copyToClipBoard(this.state.hasError?.stack), color: _ui_1.Icon.COLORS.DARK_BLUE })),
                                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
                                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM },
                                        window.location.href + '\n',
                                        this.state.hasError.stack
                                            ? this.state.hasError.stack
                                            : null))))))))
            /* <>
              <a
                 target='_blank'
                 rel='noopener noreferrer'
                 href='http://help.dayswaps.com/cs/articles/3704734-technicke-problemy-na-strane-prohlizece'
            </> */
            );
        }
        return this.props.children;
    }
}
exports.default = ErrorBoundary;
